import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import {objectToQueryParams} from "@/utils/publicFun";
import ListView from "@/components/AntListView";

/**
 * @description 规则
 * @return {/culturalExchange_gold/collectionRecord}
 */

const CollectionRecord = () => {

  return (
    <div className={Styles.collectionRecord}>
      <img src={require('@/assets/img/culturalExchange_kangyang/txtimg3.png')} alt="规则3" />
    </div>
  )
}

export default CollectionRecord
